/* jquery */
global.$ = global.jQuery = require('jquery');

/* bootstrap */
require('popper.js');
require('bootstrap');

// for supporting Object.keys not compatible in IE
require('@babel/polyfill');

/* sprintf (POedit) */
require('sprintf-js');

// Service Worker
require('../sw/core/register-sw');

require('./speech-check');

const dayjs = require('dayjs');

window.dayjs = dayjs.default ? dayjs.default : dayjs;

/* GSAP FOR ANIMATION */
import {TweenMax, Power2, Draggable,  TimelineLite, TimelineMax, CSSRulePlugin, Circ} from 'gsap/all';

window.TweenMax = TweenMax;
window.Power2 = Power2;
window.TimelineLite = TimelineLite;
window.TimelineMax = TimelineMax;
window.CSSRulePlugin = CSSRulePlugin;
window.Circ = Circ;
window.Draggable = Draggable;



import noUiSlider from 'nouislider';

window.noUiSlider = noUiSlider;

import LazyLoad from 'vanilla-lazyload';

window.lazyLoadInstance = new LazyLoad({
    elements_selector: "img"
    // ... more custom settings?
});

/* SCROLL REVEAL */
window.ScrollReveal = require('scrollreveal').default;
window.initReveal = require('./global').initReveal;

/* header */
require('./header');

/* footer */
require('./footer');

/* ariane */
require('./ariane');

/* general */
require('./general');

const { checkSelectedMagTimestamp } = require('./global');
checkSelectedMagTimestamp();

/* panier */
require('./panier');

$( window ).bind( "beforeprint", function() { 
    window.lazyLoadInstance.update();
} );